import { Box, useTheme, styled } from "@mui/material";

const SvgContainer = styled("svg")(({ theme }) => ({
  width: "26px",
  height: "26px",
  [theme.breakpoints.down("sm")]: {
    width: "20px",
    height: "20px",
  },
}));

const SuccessIcon = () => {
  const theme = useTheme();
  return (
    <SvgContainer xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <g data-name="Group 21609">
        <path
          data-name="Path 15781"
          d="M13 0A13 13 0 1 1 0 13 13 13 0 0 1 13 0z"
          style={{ fill: "#f6f8fa" }}
        />
        <path
          data-name="Path 15221"
          d="M94.894 115.517a1.138 1.138 0 0 1 0 1.5l-6.029 6.683a.861.861 0 0 1-1.3.026l-3.192-3.245A1.161 1.161 0 0 1 84.3 119a.869.869 0 0 1 1.324-.053l2.53 2.586 5.391-6.016a.875.875 0 0 1 1.349 0z"
          transform="translate(-76.248 -106.508)"
          style={{
            stroke: theme.vars.palette.text.primary,
            fill: theme.vars.palette.text.primary,
            strokeWidth: ".25px",
          }}
        />
      </g>
    </SvgContainer>
  );
};

export const StatusIcon = ({
  success,

  errorColor,
}: {
  success: boolean;

  errorColor?: string;
}) => {
  if (success) {
    return (
      <Box
        sx={(theme) => ({
          color: errorColor ?? theme.vars.palette.error.main,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
        })}
      >
        <SuccessIcon />
      </Box>
    );
  }

  return null;
};
